// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toaster{position:fixed;z-index:600}.toaster-top-left{left:40px;top:20px}.toaster-top-right{right:40px;top:20px}.toaster-bottom-left{bottom:20px;left:40px}.toaster-bottom-right{bottom:20px;right:40px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
